import { Address, DraftParty } from '~/types'

export const formatAddress = (a: Address): string => {
  return `${a.addressLine1}, ${a.city} ${a.state} ${a.postcode}, ${a.country}`
}

export const addressV2Populated = (a: Address | undefined | null): boolean => {
  if (!a) {
    return false
  }

  const fieldPresent = (f: string) => {
    return f.trim().length > 0
  }

  return (
    fieldPresent(a.addressLine1) &&
    fieldPresent(a.country) &&
    fieldPresent(a.postcode) &&
    fieldPresent(a.state as string) &&
    fieldPresent(a.city)
  )
}

/**
 * Check if Address V1 or V2 is present
 * @param party
 * @returns boolean
 */
export const addressExists = (party: DraftParty): boolean => {
  return (party.addressV2 && addressV2Populated(party.addressV2)) || !!party.address
}

/**
 * Returns Address V2 or defaults to V1
 * @param party
 */
export const addressV2OrDefault = (party: DraftParty) => {
  return party.addressV2 && addressV2Populated(party.addressV2) ? formatAddress(party.addressV2) : party.address
}
